<template>
    <!-- Decorative only. The loading announcement is a live region the call site keeps mounted, so
         that the trigger is a text change; a region that appears already holding its text is not
         reliably announced. -->
    <div v-if="label" class="loading-container" aria-hidden="true">
        <div class="spinner" :class="size"></div>
        <span>{{ label }}</span>
    </div>
    <div v-else class="spinner" :class="size" aria-hidden="true"></div>
</template>

<script setup lang="ts">
interface Props {
    size?: 'sm' | 'md' | 'lg';
    label?: string;
}

withDefaults(defineProps<Props>(), {
    size: 'md',
    label: undefined,
});
</script>

<style lang="scss" scoped>
.loading-container {
    @apply flex flex-col items-center justify-center py-12 gap-4;

    span {
        @apply text-gray-600 text-sm;
    }
}

.spinner {
    @apply border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin;

    &.sm {
        @apply w-6 h-6;
    }

    &.md {
        @apply w-8 h-8;
    }

    &.lg {
        @apply w-12 h-12;
    }
}
</style>
